// extracted by mini-css-extract-plugin
module.exports = {"w15kg74w":"w15kg74w","b1btlj5u":"b1btlj5u"};